// src/components/ScanButton.tsx
import React from 'react';
import './ScanButton.css';

interface ScanButtonProps {
  onClick: () => void;
  disabled: boolean;
}

const ScanButton: React.FC<ScanButtonProps> = ({ onClick, disabled }) => {
  return (
    <button 
      className={`scan-button ${disabled ? 'disabled' : ''}`}
      onClick={onClick}
      disabled={disabled}
    >
      Scan File
    </button>
  );
};


export default ScanButton;